    <template>
      <div class="page-body">
          <div class="container-fluid">
            <Loader :loading="isLoading" />
            <loader-component v-if="isLoading" :loading="isLoading" />
                <div class="card">
                  <div class="card-body add-post">
                    <div class="controls-wrapper">
                      <!-- Mostrar: dropdown para seleccionar usuarios por página -->
                      <div class="d-flex align-items-center mb-3">
                        <span class="me-2">Mostrar:</span>
                        <select 
                          v-model="usersPerPage" 
                          @change="resetPagination"
                          class="form-select w-auto"
                        >
                          <option :value="10">10</option>
                          <option :value="50">50</option>
                          <option :value="100">100</option>
                        </select>
                        <span class="ms-2">registros</span>
                      </div>

                      <!-- Container para botón y filtros -->
                      <div class="filters-container d-flex justify-content-between align-items-center">
                        <!-- Botón a la izquierda -->
                        <button @click="goToUserForm" class="custom-create-btn">
                          <span class="custom-create-btn-text">Crear usuario</span>
                        </button>

                        <!-- Contenedor de filtros a la derecha -->
                        <div class="filters-group d-flex align-items-center">
                          <select 
                            id="role-filter" 
                            class="px-4 py-[9px] bg-white rounded-md text-neutral-500 text-sm font-light font-['Poppins'] leading-normal border border-gray-200" 
                            v-model="selectedRole"
                          >
                            <option value="">Selecciona un Rol</option>
                            <option 
                              v-for="role in roles.filter(r => ['Admin', 'Tuiner'].includes(r.name))" 
                              :key="role.name" 
                              :value="role.name"
                            >
                              {{ role.name }}
                            </option>
                          </select>

                          <select 
                            v-model="selectedStatus" 
                            class="px-4 py-[9px] bg-white rounded-md text-neutral-500 text-sm font-light font-['Poppins'] leading-normal border border-gray-200"
                          >
                            <option value="">Todos los estatus</option>
                            <option value="Activo">Activo</option>
                            <option value="Desactivado">Desactivado</option>
                            <option value="Bloqueado">Bloqueado</option>
                          </select>

                          <!-- Buscador -->
                          <input
                            type="text"
                            class="w-64 px-4 py-[9px] bg-white rounded-md text-neutral-500 text-sm font-light font-['Poppins'] leading-normal border border-gray-200"
                            placeholder="Buscar"
                            v-model="searchQuery"
                          />   
                        </div> 
                      </div>    
                      </div>
                      <div class="row my-3">
                        <div class="w-full ">
                        </div>
                      </div>
                        <div class="overflow-x-auto">
                          <table class="min-w-full bg-white border border-gray-200 rounded-lg">
                            <thead class="bg-gray-100 text-gray-600 uppercase text-sm leading-normal">
                                <tr>
                                    <th class="hidden md:table-cell" ></th>
                                    <th class="py-3 px-6 text-style-custom text-left">Nombre</th>
                                    <th class="py-3 px-6 text-style-custom text-left hidden md:table-cell">Rol</th>
                                    <th class="py-3 px-6 text-style-custom text-left hidden md:table-cell">Email</th>
                                    <th class="py-3 px-6 text-style-custom text-left">Estatus</th>
                                    <th class="py-3 px-6 text-style-custom text-left hidden md:table-cell">Acción</th>
                                </tr>
                            </thead>
                            <tbody class="text-gray-600 text-sm font-light">
                              <tr v-for="(user, index) in filteredUsers" :key="user.id" class="border-b border-gray-200 hover:bg-gray-100"
                                :class="{'bg-white': index % 2 === 0, // Filas pares (índice empieza desde 0)
                                'bg-gray-100': index % 2 !== 0    // Filas impares
                                }"
                              >
                                <td class="py-4 px-6 custom-width-text whitespace-nowrap hidden md:table-cell"
                                :class="{'opacity-50': user.status === 'Bloqueado' || user.status === 'Desactivado'}">
                                  <svg 
                                    @click="showUserDetails(user)" 
                                    xmlns="http://www.w3.org/2000/svg" 
                                    width="24" 
                                    height="24" 
                                    viewBox="0 0 24 24" 
                                    fill="none" 
                                    :class="{'cursor-pointer': user.status === 'Desactivado' || user.status === 'delete'}">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M15 7.5C15 8.29565 14.6839 9.05871 14.1213 9.62132C13.5587 10.1839 12.7956 10.5 12 10.5C11.2044 10.5 10.4413 10.1839 9.87868 9.62132C9.31607 9.05871 9 8.29565 9 7.5C9 6.70435 9.31607 5.94129 9.87868 5.37868C10.4413 4.81607 11.2044 4.5 12 4.5C12.7956 4.5 13.5587 4.81607 14.1213 5.37868C14.6839 5.94129 15 6.70435 15 7.5ZM12 12C13.1935 12 14.3381 11.5259 15.182 10.682C16.0259 9.83807 16.5 8.69347 16.5 7.5C16.5 6.30653 16.0259 5.16193 15.182 4.31802C14.3381 3.47411 13.1935 3 12 3C10.8065 3 9.66193 3.47411 8.81802 4.31802C7.97411 5.16193 7.5 6.30653 7.5 7.5C7.5 8.69347 7.97411 9.83807 8.81802 10.682C9.66193 11.5259 10.8065 12 12 12ZM21 19.5C21 21 19.5 21 19.5 21H4.5C4.5 21 3 21 3 19.5C3 18 4.5 13.5 12 13.5C19.5 13.5 21 18 21 19.5ZM19.5 19.494C19.4985 19.125 19.269 18.015 18.252 16.998C17.274 16.02 15.4335 15 12 15C8.565 15 6.726 16.02 5.748 16.998C4.731 18.015 4.503 19.125 4.5 19.494H19.5Z" fill="#FF4265"/>
                                  </svg>
                                </td>
                                <td class="py-4 px-6 custom-width-text whitespace-nowrap " :class="{'opacity-50': user.status === 'Desactivado' || user.status === 'Bloqueado'}" style="white-space: pre-wrap;">{{ user.name }} {{ user.last_name }} {{ user.last_second_name }}</td>
                                <td class="py-4 px-6 custom-width-text whitespace-nowrap hidden md:table-cell" :class="{'opacity-50': user.status === 'Desactivado' || user.status === 'Bloqueado'}"  style="white-space: pre-wrap;" >{{ getRoles(user) }}</td>
                                <td class="py-4 px-6 custom-width-text whitespace-nowrap hidden md:table-cell" :class="{'opacity-50': user.status === 'Desactivado' || user.status === 'Bloqueado'}">{{ user.email }}</td>
                                <td class="py-4 px-6 custom-width-text whitespace-nowrap">
                                  <span class="status-indicator" :class="{ 'bg-yellow': user.status === 'Bloqueado','bg-red': user.status === 'Desactivado', 'bg-green': user.status !== 'Bloqueado' && user.status !== 'Desactivado'}">
                                    {{ user.status }}
                                  </span>
                                </td>
                                <td class="py-4 px-6 custom-width-text whitespace-nowrap">
                                  <div class="relative" ref="menuContainer">
                                    <div 
                                      class="flex items-center justify-center w-10 h-10 rounded-full cursor-pointer hover:bg-gray-200"
                                      @click="toggleMenu(user.id)">
                                      <!-- Ícono de los tres puntos -->
                                      <svg 
                                        xmlns="http://www.w3.org/2000/svg" 
                                        width="17" 
                                        height="4" 
                                        viewBox="0 0 17 4" 
                                        fill="none">
                                        <path 
                                          fill-rule="evenodd" 
                                          clip-rule="evenodd" 
                                          d="M1.96152 0C3.04429 0 3.92304 0.896031 3.92304 2C3.92304 3.10397 3.04425 4 1.96152 4C0.878748 4 0 3.10397 0 2C0 0.896031 0.878792 0 1.96152 0ZM8.49978 0C9.58255 0 10.4613 0.896031 10.4613 2C10.4613 3.10397 9.58251 4 8.49978 4C7.41705 4 6.53826 3.10397 6.53826 2C6.53826 0.896031 7.41705 0 8.49978 0ZM15.0385 0C16.1213 0 17 0.896031 17 2C17 3.10397 16.1212 4 15.0385 4C13.9557 4 13.077 3.10397 13.077 2C13.077 0.896031 13.9557 0 15.0385 0Z" 
                                          fill="#FF4265"/>
                                      </svg>
                                    </div>
                                    <div v-show="menuVisible === user.id" :class="{
                                      'absolute right-0 bg-white border shadow-lg mt-1 w-48 z-10': true,
                                      'bottom-full mb-1': filteredUsers.indexOf(user) === filteredUsers.length - 1, // Si es el último registro, despliega hacia arriba
                                      'top-full mt-1': filteredUsers.indexOf(user) < filteredUsers.length - 1 // De lo contrario, despliega hacia abajo
                                    }">
                                      <ul class="py-1">
                                        <li class="px-4 py-2 hover:bg-gray-100 cursor-pointer" @click="profileUser(user.id)">Ver Perfil</li>
                                        
                                        <!-- Mostrar Editar y Bloquear solo si el estado es diferente de Desactivado o Bloqueado -->
                                        <li 
                                          v-if="user.status !== 'Desactivado' && user.status !== 'Bloqueado'" 
                                          class="px-4 py-2 hover:bg-gray-100 cursor-pointer" 
                                          @click="editUser(user.id)"
                                        >
                                          Editar
                                        </li>
                                        <li 
                                          v-if="user.status !== 'Desactivado' && user.status !== 'Bloqueado'" 
                                          class="px-4 py-2 hover:bg-gray-100 cursor-pointer" 
                                          @click="block_user(user.id)"
                                        >
                                          Bloquear
                                        </li>

                                        <li 
                                          v-if="user.status === 'Desactivado' || user.status === 'Bloqueado'" 
                                          class="px-4 py-2 hover:bg-gray-100 cursor-pointer text-green-500" 
                                          @click="confirmActive(user.id)"
                                        >
                                          Activar
                                        </li>
                                        <li 
                                          v-else 
                                          class="px-4 py-2 hover:bg-gray-100 cursor-pointer text-red-500" 
                                          @click="delete_user(user.id)"
                                        >
                                          Desactivar
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <div v-if="successMessage" style="color: green; margin-top: 10px;">
                            {{ successMessage }}
                          </div>
                          <BlockUser_modal
                            :isVisible="showBlockModal"
                            @confirm="confirmBlock"
                            @cancel="closeModal"
                          />
                          <div v-if="showDeleteModal" class="modal-overlay" style="display: flex; justify-content: center; align-items: center; position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0, 0, 0, 0.5);">
                            <div class="modal-content" style="display: flex; flex-direction: column; width: 623px; padding-bottom: 26px; background: white; border-radius: 8px;">
                              <!-- Modal Header -->
                              <div class="modal-header" style="display: flex; justify-content: space-between; align-items: center; padding: 16px;">
                                <h3>¿Seguro que deseas desactivar a este usuario?</h3>
                                <button type="button" class="btn-close" @click="closeModal" style="background: none; border: none; font-size: 20px;">×</button>
                              </div>
                              <!-- Modal Body -->
                              <div class="modal-header" style="padding: 16px; display: flex; align-items: center; gap: 4px; justify-content: flex-start;">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" style="margin-right: 2px;">
                                      <path d="M6.875 6.875C7.04076 6.875 7.19973 6.94085 7.31694 7.05806C7.43415 7.17527 7.5 7.33424 7.5 7.5V15C7.5 15.1658 7.43415 15.3247 7.31694 15.4419C7.19973 15.5592 7.04076 15.625 6.875 15.625C6.70924 15.625 6.55027 15.5592 6.43306 15.4419C6.31585 15.3247 6.25 15.1658 6.25 15V7.5C6.25 7.33424 6.31585 7.17527 6.43306 7.05806C6.55027 6.94085 6.70924 6.875 6.875 6.875ZM10 6.875C10.1658 6.875 10.3247 6.94085 10.4419 7.05806C10.5592 7.17527 10.625 7.33424 10.625 7.5V15C10.625 15.1658 10.5592 15.3247 10.4419 15.4419C10.3247 15.5592 10.1658 15.625 10 15.625C9.83424 15.625 9.67527 15.5592 9.55806 15.4419C9.44085 15.3247 9.375 15.1658 9.375 15V7.5C9.375 7.33424 9.44085 7.17527 9.55806 7.05806C9.67527 6.94085 9.83424 6.875 10 6.875ZM13.75 7.5C13.75 7.33424 13.6842 7.17527 13.5669 7.05806C13.4497 6.94085 13.2908 6.875 13.125 6.875C12.9592 6.875 12.8003 6.94085 12.6831 7.05806C12.5658 7.17527 12.5 7.33424 12.5 7.5V15C12.5 15.1658 12.5658 15.3247 12.6831 15.4419C12.8003 15.5592 12.9592 15.625 13.125 15.625C13.2908 15.625 13.4497 15.5592 13.5669 15.4419C13.6842 15.3247 13.75 15.1658 13.75 15V7.5Z" fill="#FF4265"/>
                                      <path fill-rule="evenodd" clip-rule="evenodd" d="M18.125 3.75C18.125 4.08152 17.9933 4.39946 17.7589 4.63388C17.5245 4.8683 17.2065 5 16.875 5H16.25V16.25C16.25 16.913 15.9866 17.5489 15.5178 18.0178C15.0489 18.4866 14.413 18.75 13.75 18.75H6.25C5.58696 18.75 4.95107 18.4866 4.48223 18.0178C4.01339 17.5489 3.75 16.913 3.75 16.25V5H3.125C2.79348 5 2.47554 4.8683 2.24112 4.63388C2.0067 4.39946 1.875 4.08152 1.875 3.75V2.5C1.875 2.16848 2.0067 1.85054 2.24112 1.61612C2.47554 1.3817 2.79348 1.25 3.125 1.25H7.5C7.5 0.918479 7.6317 0.600537 7.86612 0.366117C8.10054 0.131696 8.41848 0 8.75 0L11.25 0C11.5815 0 11.8995 0.131696 12.1339 0.366117C12.3683 0.600537 12.5 0.918479 12.5 1.25H16.875C17.2065 1.25 17.5245 1.3817 17.7589 1.61612C17.9933 1.85054 18.125 2.16848 18.125 2.5V3.75ZM5.1475 5L5 5.07375V16.25C5 16.5815 5.1317 16.8995 5.36612 17.1339C5.60054 17.3683 5.91848 17.5 6.25 17.5H13.75C14.0815 17.5 14.3995 17.3683 14.6339 17.1339C14.8683 16.8995 15 16.5815 15 16.25V5.07375L14.8525 5H5.1475ZM3.125 3.75V2.5H16.875V3.75H3.125Z" fill="#FF4265"/>
                                  </svg>
                                  <p style="margin:0;">Al desactivar a un usuario, no se eliminan los inmuebles que administra.</p>
                              </div>
                              <!-- Modal Footer -->
                              <div class="modal-footer" style="display: flex; justify-content: flex-end; align-items: center; gap: 10px; padding: 10px 16px;">
                                
                                <button @click="closeModal" style="padding: 10px 16px; border-radius: 4px; background: var(--Neutral-Ne-Medium-Weak, #737373); color: #fff; border: none;">
                                  Cancelar
                                </button>
                                <button @click="confirmDelete" style="padding: 10px 16px; border-radius: 4px; background: var(--Primary-Primary, #FF4265); color: #fff; border: none;">
                                  Confirmar
                                </button>
                              </div>
                            </div>
                          </div>
                          <div v-if="successMessage" class="user-alert">
                              <div class="user-alert-content">
                                  <div class="user-alert-text">
                                      {{ successMessage }}
                                  </div>
                              </div>
                              <div class="w-4 h-4 relative"></div>
                          </div>
                          <div v-if="showUserDetailsModal" class="modal-overlay">
                            <div class="modal-content" style="display: flex; flex-direction: column; width: 623px; padding-bottom: 26px; background: white; border-radius: 8px;">
                              <div class="modal-header" style="display: flex; justify-content: space-between; align-items: center; padding: 16px;">
                                <h3>Roles del usuario {{ selectedUser?.name }}</h3>
                                <button type="button" class="btn-close" @click="closeUserDetailsModal" style="background: none; border: none; font-size: 20px;">×</button>
                              </div>
                              <!-- Modal Body -->
                              <div class="modal-body" style="padding: 16px; display: flex; align-items: center; gap: 4px; justify-content: flex-start;">
                                <svg xmlns="http://www.w3.org/2000/svg" width="1.2rem" height="1.2rem" viewBox="0 0 15 15">
                                  <path fill="#FF4265" fill-rule="evenodd" d="M1.903 7.297c0 3.044 2.207 5.118 4.686 5.547a.521.521 0 1 1-.178 1.027C3.5 13.367.861 
                                  10.913.861 7.297c0-1.537.699-2.745 1.515-3.663c.585-.658 1.254-1.193 1.792-1.602H2.532a.5.5 0 0 1 0-1h3a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 
                                  0V2.686l-.001.002c-.572.43-1.27.957-1.875 1.638c-.715.804-1.253 1.776-1.253 2.97m11.108.406c0-3.012-2.16-5.073-4.607-5.533a.521.521 0 1 1 .192-1.024c2.874.54 5.457 2.98 5.457 
                                  6.557c0 1.537-.699 2.744-1.515 3.663c-.585.658-1.254 1.193-1.792 1.602h1.636a.5.5 0 1 1 0 1h-3a.5.5 0 0 1-.5-.5v-3a.5.5 0 1 1 1 0v1.845h.002c.571-.432 1.27-.958 1.874-1.64c.715-.803 1.253-1.775 1.253-2.97" clip-rule="evenodd"/>
                                </svg>
                                  <p style="margin:0;">Asigna los roles del usuario.</p>
                              </div>
                              <div class="modal-header" style="padding: 16px; display: flex; align-items: center; gap: 4px; justify-content: flex-start;">
                                <!-- Sección de roles dentro del modal -->
                                <div class="mb-3 col-12 col-md-4">
                                  <div class="roles-container" style="display: flex; flex-direction: column; align-items: flex-start;">
                                    <div v-for="rol in roles" :key="rol.id" class="checkbox-checked">
                                      <input
                                        class="form-check-input"
                                        :id="'rol_' + rol.id"
                                        type="checkbox"
                                        :value="rol.id"
                                        v-model="selectedRoles"
                                      />
                                      <label class="form-check-label" :for="'rol_' + rol.id">{{ rol.name }}</label>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <!-- Botones de acción -->
                               <!-- Modal Footer -->
                                <div class="modal-footer" style="display: flex; justify-content: flex-end; align-items: center; gap: 10px; padding: 10px 16px;">
                                  
                                  <button @click="closeUserDetailsModal" style="padding: 10px 16px; border-radius: 4px; background: var(--Neutral-Ne-Medium-Weak, #737373); color: #fff; border: none;">
                                    Cancelar
                                  </button>
                                  <button @click="saveSelectedRoles(selectedUser.id)" style="padding: 10px 16px; border-radius: 4px; background: var(--Primary-Primary, #FF4265); color: #fff; border: none;">
                                    Confirmar
                                  </button>
                                </div> 
                            </div>
                          </div>
                        </div>
                        <!-- Controles de paginación -->
                        <div class="pagination-wrapper">
                            <!-- Botón para página anterior -->
                            <button 
                              @click="changePage(page - 1)" 
                              :disabled="page === 1"
                              :style="{padding: '8px 12px', border: '1px solid var(--Primary-Primary,  #FFD8DF)', background: 'var(--Primary-Primary, #FFF)', color: '#FF4265', opacity: page === 1 ? '0.5' : '1',cursor: page === 1 ? 'not-allowed' : 'pointer' }"
                            >
                              &lt;
                            </button>

                            <!-- Números de página -->
                            <div style="display: flex; gap: 0; align-items: center;">
                              <button
                                v-for="pageNumber in totalPages" 
                                :key="pageNumber" @click="changePage(pageNumber)" 
                                :style="{padding: '8px 12px',border: '1px solid var(--Primary-Primary,  #FFD8DF)',background: pageNumber === page ? '#FF4265' : 'var(--Primary-Primary, #FFF)',color: pageNumber === page ? '#FFF' : '#FF4265',fontWeight: pageNumber === page ? 'bold' : 'normal',
                                  cursor: 'pointer'
                                }"
                              >
                                {{ pageNumber }}
                              </button>
                            </div>

                            <!-- Botón para página siguiente -->
                            <button @click="changePage(page + 1)" 
                              :disabled="page >= totalPages"
                              :style="{padding: '8px 12px',border: '1px solid var(--Primary-Primary,  #FFD8DF)',background: 'var(--Primary-Primary, #FFF)',color: '#FF4265',opacity: page >= totalPages ? '0.5' : '1',cursor: page >= totalPages ? 'not-allowed' : 'pointer'
                              }"
                            >
                              &gt;
                            </button>
                          </div>
                    </div>
                    <head>
                        <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600&display=swap" rel="stylesheet">
                    </head>
                  </div>
                </div>
              </div>
    </template>


<script setup>
import { ref, onMounted, onUnmounted , watch} from 'vue';
import { useRouter } from 'vue-router';
import axios from 'axios';
import { computed } from "vue";
import { useStore } from 'vuex';
import BlockUser_modal from './modal/BlockUser_modal.vue';
import 'vue-toastification/dist/index.css';
import Loader from '@/components/loaderComponent.vue';



// Referencias y estado
const isLoading = ref(true); // Inicializamos isLoading
const users = ref([]);
const page = ref(1); // Página actual
const usersPerPage = ref(12); // Número de usuarios por página
const searchQuery = ref("");  // Para almacenar el término de búsqueda
const selectedRole = ref(''); // Rol seleccionado
const menuVisible = ref(null);
const store = useStore();
let session = computed(() => store.getters.getUserSession);
const router = useRouter();
const showBlockModal = ref(false); // Controla la visibilidad del modal
const showDeleteModal = ref(false); // Controla la visibilidad del modal
const selectedUserId = ref(null);
const showUserDetailsModal = ref(false); // Controla la visibilidad del modal de detalles de usuario
const selectedUser = ref(null); // Almacena el usuario seleccionado
const roles = ref([]); // Aquí guardaremos todos los roles
const selectedRoles = ref([]); // Aquí se almacenan los roles seleccionados
const successMessage = ref(''); // Esta variable se utilizará para mostrar el mensaje
const selectedStatus = ref("");
//const selectedRoles = ref([]); // Aquí guardaremos los roles seleccionados

// Métodos

const fetchUsers = async () => {
  isLoading.value = true;
  try {
    let options = {
      headers: {
        'Authorization': `Bearer ${session.value.token_api}`
      }
    };

    const response = await axios.get(`${process.env.VUE_APP_API_BASE_URL}/broker/getrs-users`, options);

    if (response.data && response.data.original && Array.isArray(response.data.original.data)) {
      // Traducir el estado de cada usuario
      users.value = response.data.original.data.map(user => ({
        ...user,
        status: translateStatus(user.status) // Traducir el estado aquí
      }));
    } else {
      users.value = [];
      console.error("La respuesta no contiene una lista de usuarios válida.");
    }
  } catch (error) {
    if (error.response && error.response.status === 401) {
      store.dispatch('clearUserSession');
    }
    console.error("Error al obtener los usuarios", error);
    users.value = [];
  } finally {
    isLoading.value = false;
  }
};

const translateStatus = (status) => {
  const statusTranslations = {
    active: 'Activo',
    delete: 'Desactivado',
    block: 'Bloqueado',
    pending: 'Pendiente',
    // Agrega más traducciones según sea necesario
  };

  return statusTranslations[status] || status; // Devuelve el estado original si no se encuentra traducción
};

    // Cambiar la página
    const changePage = (newPage) => {
      if (newPage >= 1 && newPage <= totalPages.value) {
        page.value = newPage;
      }
    };
// Método para obtener todos los roles
const fetchRoles = async () => {
  try {
    let options = {
      headers: {
        'Authorization': `Bearer ${session.value.token_api}`
      }
    };
    const response = await axios.get(`${process.env.VUE_APP_API_BASE_URL}/roles`, options);
    
    // Verifica si la respuesta es un error de autorización
    if (response.status === 401) {
      store.dispatch('clearUserSession');
    }

    if (response.status === 200) {
      roles.value = response.data; // Asigna los roles correctamente
      console.log(roles.value)
    }
  } catch (error) {
    console.error("Error al obtener los roles:", error);
  }
};


  const filterUsers = () => {
      const query = searchQuery.value.toLowerCase();
      filteredUsers.value = users.value.filter(user => {
        const matchesRole = selectedRole.value ? user.role === selectedRole.value : true;
        console.log(selectedRole.value)
        const matchesSearch =
          user.name.toLowerCase().includes(query) ||
          user.email.toLowerCase().includes(query);
        return matchesRole && matchesSearch;
      });
    };

    // Reacciones a cambios en `searchQuery` o `selectedRole`
    watch([searchQuery, selectedRole], filterUsers);

    const resetPagination = () => {
      page.value = 1; // Reset to first page
    };
const filteredUsers = computed(() => {
  let filtered = users.value.filter(user =>
    user.name.toLowerCase().includes(searchQuery.value.toLowerCase()) ||
    user.last_name.toLowerCase().includes(searchQuery.value.toLowerCase()) ||
    user.email.toLowerCase().includes(searchQuery.value.toLowerCase())
  );

  if (selectedRole.value && selectedRole.value !== '') {
    filtered = filtered.filter(user =>
      user.roles.some(role => role.name.toLowerCase() === selectedRole.value.toLowerCase())
    );
  }

  // Filter by status
  if (selectedStatus.value) {
    filtered = filtered.filter(compani => 
      compani.status === selectedStatus.value
    );
  }


  const startIndex = (page.value - 1) * usersPerPage.value;
  const endIndex = startIndex + usersPerPage.value;

  return filtered.slice(startIndex, endIndex);
});


const totalPages = computed(() => {
  let filteredTotal = users.value.filter(user =>
    user.name.toLowerCase().includes(searchQuery.value.toLowerCase()) ||
    user.last_name.toLowerCase().includes(searchQuery.value.toLowerCase()) ||
    user.email.toLowerCase().includes(searchQuery.value.toLowerCase())
  );

  if (selectedRole.value && selectedRole.value !== '') {
    filteredTotal = filteredTotal.filter(user =>
      user.roles.some(role => role.name.toLowerCase() === selectedRole.value.toLowerCase())
    );
  }

  // Include status filtering
  if (selectedStatus.value) {
    filteredTotal = filteredTotal.filter(user => 
      user.status === selectedStatus.value
    );
  }

  return Math.ceil(filteredTotal.length / usersPerPage.value);
});
const showUserDetails = (user) => {
  selectedUser.value = user;
  showUserDetailsModal.value = true;
  selectedRoles.value = user.roles.map(role => role.id);
  const roles = Array.isArray(user.roles) ? user.roles.map(role => role.id) : [];
  console.log(roles); // Confirmar que roles se maneja correctamente

  showUserDetailsModal.value = true;
};
const saveSelectedRoles = async (userId) => {
  try {
    // Asegurarse de que selectedRoles sea un array de enteros
    const rolesArray = Array.isArray(selectedRoles.value) 
    ? selectedRoles.value.map(role => parseInt(role, 10)) 
    : [];

    // Si no hay roles seleccionados, no proceder
    if (rolesArray.length === 0) {
      showToast('No se han seleccionado roles.');
      return;
    }

    // Configurar encabezados con el token de autenticación
    let options = {
      headers: {
        'Authorization': `Bearer ${session.value.token_api}`,
        'Content-Type': 'application/json'
      }
    };

    // Datos a enviar (incluyendo el ID de usuario y los roles seleccionados)
    const data = {
      broker_id: userId, // El ID del broker
      rol: rolesArray // Los roles como un array de números enteros
    };

    // Enviar solicitud PUT a la API
    const response = await axios.put(
      `${process.env.VUE_APP_API_BASE_URL}/broker/profile/update-roles`, 
      data, 
      options
      
    );
    fetchUsers();
    // Verificar la respuesta y mostrar un mensaje
    if (response.data.status === 'error') {
      showToast('Hubo un error al actualizar los roles. Intenta nuevamente.');
    } else {
      showToast('Roles actualizados con éxito');
      closeUserDetailsModal();  // Cerrar el modal
    }

  } catch (error) {
    console.error('Error al actualizar roles:', error);
    showToast('Hubo un error al actualizar los roles. Intenta nuevamente.');
  }
};

const block_user = (user_id) => {
  selectedUserId.value = user_id; // Almacena el ID del usuario
  showBlockModal.value = true;     // Muestra el modal
};

const delete_user = (user_id) => {
  selectedUserId.value = user_id; // Almacena el ID del usuario
  showDeleteModal.value = true;     // Muestra el modal
};

const confirmBlock = async () => {
  try {
    let options = {
      headers: {
        'Authorization': `Bearer ${session.value.token_api}`,
        'Content-Type': 'application/json'
      }
    };
    const data = { user_id_block: selectedUserId.value };
    const response = await axios.post(
      `${process.env.VUE_APP_API_BASE_URL}/broker/profile/block_user`, 
      data, 
      options
    );

    if (response.data.success) {
      showToast('Usuario bloqueado');  // Mostrar la notificación flotante de éxito
      showBlockModal.value = false;    // Cierra el modal
      fetchUsers();                    // Recargar la lista de usuarios
    } else {
      showToast('Hubo un error al bloquear el usuario. Intenta nuevamente.');
    }

  } catch (error) {
    console.error('Error al bloquear el usuario', error);
    showToast('Hubo un error al bloquear el usuario. Intenta nuevamente.');
  }
};

const showToast = (message) => {
  successMessage.value = message;
  setTimeout(() => {
    successMessage.value = ''; // Ocultar el mensaje después de 3 segundos
  }, 3000);
};
const confirmDelete = async () => {
  try {
    let options = {
      headers: {
        'Authorization': `Bearer ${session.value.token_api}`,
        'Content-Type': 'application/json',
      },
    };
    const data = { user_id_delete: selectedUserId.value };

    const response = await axios.post(
      `${process.env.VUE_APP_API_BASE_URL}/broker/profile/delete_user`, 
      data, 
      options
    );

    if (response.data.success) {
      showToast(response.data.message);  // Mostrar notificación flotante
      showDeleteModal.value = false;
      fetchUsers();
    } else {
      showToast('Hubo un error al eliminar el usuario. Intenta nuevamente.');
    }
  } catch (error) {
    console.error('Error al eliminar el usuario', error);
    showToast('Hubo un error al eliminar el usuario. Intenta nuevamente.');
  }
};

const confirmActive = async (user_id) => {
  selectedUserId.value = user_id; // Almacena el ID del usuario
  try {
    let options = {
      headers: {
        'Authorization': `Bearer ${session.value.token_api}`,
        'Content-Type': 'application/json',
      },
    };
    const data = { user_id: selectedUserId.value };

    const response = await axios.post(
      `${process.env.VUE_APP_API_BASE_URL}/broker/profile/active_user`, 
      data, 
      options
    );

    if (response.data.success) {
      showToast(response.data.message);  // Mostrar notificación flotante
      showDeleteModal.value = false;
      fetchUsers();
    } else {
      showToast('Hubo un error al activar el usuario. Intenta nuevamente.');
    }
  } catch (error) {
    console.error('Error al activar el usuario', error);
    showToast('Hubo un error al activar el usuario. Intenta nuevamente.');
  }
};

const closeModal = () => {
  showBlockModal.value = false; // Cierra el modal
  showDeleteModal.value = false; // Cierra el modal
};
const closeUserDetailsModal = () => {
  showUserDetailsModal.value = false;
};

const getRoles = (user) => {
  // Verifica si existen roles y mapea solo el nombre de cada rol
  return user.roles && user.roles.length > 0 
    ? user.roles.map(role => role.name).join(', ')
    : 'Sin rol';
};
const goToUserForm = () => {
  router.push({ name: 'usersform' });
};

const editUser = (id) => {
  console.log("ID del usuario:", id); // Imprime el ID en la consola
  router.push({ name: 'UserForm', params: { id } }); // Asegúrate de que el nombre coincida con el de la ruta
  menuVisible.value = null; // Cierra el menú después de hacer clic
};

const profileUser = (id) => {
  console.log("ID del usuario:", id); // Imprime el ID en la consola
  router.push({ name: 'UserProfile', params: { id } }); // Asegúrate de que el nombre coincida con el de la ruta
  menuVisible.value = null; // Cierra el menú después de hacer clic
};


const toggleMenu = (userId) => {
  menuVisible.value = menuVisible.value === userId ? null : userId;
};

// Manejo de clics fuera del menú
const handleClickOutside = (event) => {
  if (!event.target.closest('.relative')) {
    menuVisible.value = null;
  }
};

// Lifecycle hooks
onMounted(() => {
  fetchUsers();
  fetchRoles();
  document.addEventListener('click', handleClickOutside);
});



onUnmounted(() => {
  document.removeEventListener('click', handleClickOutside);
});
</script>

<style scoped>

  .form-check-input:checked {
    background-color: #FF4265;  /* Cambia el color de fondo */
    border-color: #FF4265;      /* Cambia el color del borde */
  }

  /* Estilos base */
.controls-wrapper {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.records-selector {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.filters-container {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.filters-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.filter-select,
.search-input {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.375rem;
}

.custom-table {
  width: 100%;
  min-width: 300px;
}

.user-info {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.pagination-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  margin-top: 1.5rem;
  flex-wrap: wrap;
}

.pagination-btn,
.page-number {
  padding: 0.5rem 1rem;
  border: 1px solid #FF4265;
  background: white;
  color: #FF4265;
  cursor: pointer;
}

.page-number.active {
  background: #FF4265;
  color: white;
}

  /* Media queries */
  @media (min-width: 640px) {
    .filters-group {
      flex-direction: row;
      flex-wrap: wrap;
    }

    .filter-select,
    .search-input {
      width: auto;
    }
  }

  @media (min-width: 768px) {
    .controls-wrapper {
      flex-direction: column; /* Mantener en columna para que "Mostrar" esté arriba */
      align-items: flex-start; /* Alinea a la izquierda */
    }

    .filters-container {
      flex-direction: row;
      justify-content: space-between; /* Mantiene el botón a la izquierda y los filtros a la derecha */
      width: 100%; /* Asegúrate de que ocupe todo el ancho disponible */
      margin-top: 1rem; /* Añade un margen superior para separar "Mostrar" de los filtros */
    }
  }

  @media (min-width: 1024px) {
    .filters-group {
      flex-wrap: nowrap;
    }
  }
  .status-indicator {
      display: inline-block; /* Para que el span se ajuste al contenido */
      padding: 0.2rem 0.5rem; /* Espaciado interno */
      border-radius: 9999px; /* Hace que el borde sea completamente redondeado */
      color: #4A4A4A; /* Color del texto (más oscuro que el fondo) */
      text-align: center; /* Centra el texto dentro del span */
    }

    .bg-yellow {
      background-color: #fff3cd; /* Color de fondo amarillo */
      color: #664d03; /* Color del texto más oscuro (GoldenRod) */
    }

    .bg-red {
      background-color: #f8d7da; /* Color de fondo rojo */
      color: #842029; /* Color del texto más oscuro (FireBrick) */
    }

    .bg-green {
      background-color: #d1e7dd; /* Color de fondo verde */
      color: #1c5f48; /* Color del texto más oscuro (DarkGreen) */
    }
</style>